import { __assign, __extends } from "tslib";
import { RandomGenerator } from "../../test-utils";
import { ExtendedTicketBuilder } from "./extended-ticket.builder";
var CallExtendedTicketBuilder = /** @class */ (function (_super) {
    __extends(CallExtendedTicketBuilder, _super);
    function CallExtendedTicketBuilder() {
        var _this = _super.call(this) || this;
        _this.callExtendedTicket = __assign(__assign({}, _super.prototype.build.call(_this)), { currentCallId: RandomGenerator.randomId() });
        return _this;
    }
    CallExtendedTicketBuilder.prototype.withCurrentCallId = function (currentCallId) {
        this.callExtendedTicket.currentCallId = currentCallId;
        return this;
    };
    ;
    CallExtendedTicketBuilder.prototype.build = function () {
        return __assign(__assign({}, _super.prototype.build.call(this)), this.callExtendedTicket);
    };
    ;
    return CallExtendedTicketBuilder;
}(ExtendedTicketBuilder));
export { CallExtendedTicketBuilder };
;
//# sourceMappingURL=call-extended-ticket-builder.js.map